<template>
	<div>
		<v-layout row wrap>
			<v-flex md2 pt-0>
				<v-select
					class="filter-select"
					v-bind:items="subsidiaries"
					item-text="name"
					item-value="id"
					v-model="subsidiaryId"
					hide-details
					label="Sucursal"
					v-on:change="loadBuildings"
					single-line
					bottom>
				</v-select>
			</v-flex>
			<v-flex md2 pt-0>
				<v-select
					class="filter-select"
					v-bind:items="buildings"
					v-model="buildingId"
					v-bind:disabled="buildings.length === 0"
					item-text="name"
					item-value="id"
					hide-details
					v-on:change="loadRooms"
					label="Edificio"
					single-line
					bottom>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-space-between mt-3>
			<div class="wrap-select-rooms text-xs-left">
				<span class="little-subtitle-default">Seleccione las habitaciones:</span>
				<span class="subtitle-right">5 habitaciones</span>
				<v-layout row wrap mt-3>
					<room-status v-for="row in rows"
								 :key="row.id"
								 :clean-state="row.clean_state"
								 :number="row.number"
								 :code="row.code"
								 :room="row"
								 v-on:on-room-selected="updateRowsSelected"
								 :labelFor="`room-${row.number}`"
								 :roomId="row.id"
								 :extra-state="row.state"
								 :size="'medium'"
								 :status-icon="row.icon">
					</room-status>
				</v-layout>
			</div>
			<div class="select-clean-type text-xs-left">
				<span class="little-subtitle-default">Tipo de limpieza:</span>
				<div class="select-slots-housekeeping mt-2">
					<v-select v-bind:items="states"
							  item-text="name"
							  item-value="name"
							  v-model="states.filter(state => state.id === Number($route.params.stateId))[0].name"
							  chips
							  max-height="auto"
							  hide-details>
						<template slot="selection" scope="data">
							{{ data.item.name }}
							<room-status :clean-state="data.item.id"
										 :number="data.item.number"
										 :code="data.item.code"
										 :room="data.item"
										 :labelFor="`room-${data.item.number}`"
										 :extra-state="data.item.state"
										 :size="'medium'"
										 :status-icon="data.item.icon">
							</room-status>
						</template>
						<template slot="item" scope="data">
							<template>
								<v-list-tile-content>
									<v-list-tile-title v-html="data.item.name"></v-list-tile-title>
								</v-list-tile-content>
								<room-status :clean-state="data.item.id"
											 :number="data.item.number"
											 :code="data.item.code"
											 :room="data.item"
											 :extra-state="data.item.state"
											 :size="'medium'"
											 :status-icon="data.item.icon">
								</room-status>
							</template>
						</template>
					</v-select>
				</div>
			</div>
			<v-flex xs12 text-xs-left>
				<v-btn class="btn-add"
					   v-on:click="addToRowsSelected(roomsSelected)">
					Agregar
				</v-btn>
			</v-flex>
		</v-layout>
		<v-divider class="divider-full"></v-divider>
		<v-layout row wrap>
			<span class="little-subtitle-default">Asigne a la mucama:</span>
			<user-selector-list class="mt-2"
								:users="users"
								v-on:on-change-selected="onUserSelected">
			</user-selector-list>
			<v-flex md12 text-xs-left>
				<v-btn class="btn-add"
					   v-on:click="addUserSelected">
					Agregar
				</v-btn>
			</v-flex>
		</v-layout>
		<v-divider class="divider-full"></v-divider>
		<v-layout row wrap text-xs-left class="full-layout-white">
			<v-flex md6 pr-3 mb-3 class="body-border-right">
				<v-layout row wrap>
					<v-flex xs12>
						<span class="little-subtitle-default">Habitaciones:</span>
					</v-flex>
					<v-flex xs12 class="empty-container">
						<div v-if="rowsSelected" class="mt-2">
							<room-status v-for="row in rowsSelected"
										 :key="row.id"
										 :clean-state="row.clean_state"
										 :number="row.number"
										 :room="room" :code="row.code"
										 :isAdded="row.isAdded"
										 :labelFor="`room-${row.number}`"
										 :extra-state="row.state"
										 :size="'medium'"
										 :status-icon="row.icon"
										 :roomId="row.id"
										 v-on:on-room-removed="removeThisRow">
							</room-status>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12>
						<span class="little-subtitle-default">Mucamas:</span>
					</v-flex>
					<v-flex xs12>
						<user-selector v-if="userAdded"
									   :user="userAdded"
									   class="mt-2"
									   v-on:on-user-removed="userRemoved">
						</user-selector>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex md6 pl-3>
				<span class="little-subtitle-default">Tipo de limpieza:</span>
				<v-layout row wrap>
					<div v-for="type in cleanTypes"
							:key="type.id">
						<input type="radio"
							   hidden
							   name="cleanTypes"
							   v-model="cleanTypeSelected"
							   :id="type.id"
							   class="input-clean-type"
							   :value="type.id">
						<label :for="type.id" class="clean-type">
							{{ type.name }}
						</label>
					</div>
				</v-layout>
				<span class="little-subtitle-default">Comentario o sugerencia:</span>
				<v-layout row wrap>
					<textarea name="assign-comment" v-model="comment" class="mt-2 mb-3" cols="80" rows="3"></textarea>
				</v-layout>
			</v-flex>
			<v-flex xs12 text-xs-right>
				<v-btn class="btn-assign-tasks">
					Asignar a tareas
				</v-btn>
			</v-flex>
		</v-layout>
		<v-snackbar
			:timeout="timeout"
			:success="context === 'success'"
			:info="context === 'info'"
			:warning="context === 'warning'"
			:error="context === 'error'"
			:primary="context === 'primary'"
			:secondary="context === 'secondary'"
			top
			right
			v-model="snackbar">
			{{ text }}
		</v-snackbar>
	</div>
</template>

<script>
	import mixin from '@/shared/mixins';
	import RoomStatus from '@/components/shared/RoomStatus';
	import UserSelector from '@/components/shared/UserSelector';
	import UserSelectorList from '@/components/shared/UserSelectorList';

	function addToRowsSelected(rooms) {
		if (rooms && rooms.length > 0) {
			const newRooms = Object.assign([], rooms);
			if (!this.rowsSelected) {
				this.rowsSelected = [];
			}
			this.rowsSelected = newRooms;
		} else {
			if (this.rowsSelected && this.rowsSelected.length > 0) {
				this.rowsSelected = this.rowsSelected.map((row) => {
					const newRow = Object.assign({}, row);
					newRow.isAdded = true;
					return newRow;
				});
			}
			this.context = 'error';
			this.text = 'Debe seleccionar al menos 1 habitación para agregarla';
			this.snackbar = true;
		}
	}

	function addUserSelected() {
		if (this.userSelected) {
			const newUser = Object.assign({}, this.userSelected);
			newUser.isAdded = true;
			if (!this.userAdded) {
				this.userAdded = {};
			}
			this.userAdded = newUser;
		} else {
			this.context = 'error';
			this.text = 'Debe seleccionar 1 mucama para agregarla';
			this.snackbar = true;
		}
	}

	function created() {
		this.loadSubsidiaries();
		this.loadData();
	}

	async function loadBuildings(id) {
		const filterGroups = [];
		if (id) {
			this.filterBySubsidiaryId = this.renderFilter('com_subsidiaries_id', id, 'eq');
			filterGroups.push(this.filterBySubsidiaryId);
		} else {
			this.filterBySubsidiaryId = null;
		}
		this.filterByBuildingId = null;
		this.buildingId = 0;
		const response = await this.$http.get('building-simple-list', { params: { filter_groups: filterGroups } });
		this.buildings = response.data;
		this.loadData();
	}

	async function loadData() {
		const filterGroups = [];
		if (this.filterBySubsidiaryId) {
			filterGroups.push(this.filterBySubsidiaryId);
		}
		if (this.filterByBuildingId) {
			filterGroups.push(this.filterByBuildingId);
		}
		await this.$http.get('room-simple-list', { params: { filter_groups: filterGroups } });
	}

	function loadRooms(id) {
		const filterGroups = [];
		this.filterByBuildingId = this.renderFilter('hot_building_id', id, 'eq');
		filterGroups.push(this.filterByBuildingId);
		this.loadData();
	}

	function onUserSelected(user) {
		this.userSelected = user;
	}

	function removeThisRow(id) {
		const rowsIndex = this.rowsSelected.map((row) => {
			const newRowIndex = row.id;
			return newRowIndex;
		});
		const index = rowsIndex.indexOf(id) > -1 ? rowsIndex.indexOf(id) : null;
		if (index || index === 0) {
			this.rowsSelected.splice(index, 1);
		}
	}

	function updateRowsSelected(item) {
		if (!this.roomsSelected) {
			this.roomsSelected = [];
		}
		if (item.isSelected) {
			this.roomsSelected.push(item);
			this.room = item;
		} else {
			const roomsId = this.roomsSelected.map((room) => {
				const newRoomId = room.id;
				return newRoomId;
			});
			const index = roomsId.indexOf(item.id) > -1 ? roomsId.indexOf(item.id) : null;
			if (index || index === 0) {
				this.roomsSelected.splice(index, 1);
			}
		}
	}

	function userRemoved() {
		this.userAdded = null;
	}

	export default {
		components: {
			RoomStatus,
			UserSelector,
			UserSelectorList,
		},
		created,
		methods: {
			addToRowsSelected,
			addUserSelected,
			loadBuildings,
			loadData,
			loadRooms,
			onUserSelected,
			removeThisRow,
			updateRowsSelected,
			userRemoved,
		},
		mixins: mixin,
		name: 'detail-by-state',
		data() {
			return {
				buildingId: 0,
				buildings: [],
				cleanTypes: [
					{ id: 1, name: 'Normal', isSelected: 1 },
					{ id: 2, name: 'Profunda', isSelected: 0 },
					{ id: 3, name: 'Turn Over', isSelected: 0 },
				],
				cleanTypeSelected: 1,
				comment: null,
				filterByBuildingId: null,
				filterBySubsidiaryId: null,
				room: null,
				roomsSelected: null,
				rows: [
					{
						id: 1,
						code: 'OS',
						icon: 'dirty',
						number: '5201',
						clean_state: 1,
						state: 'booking',
						isSelected: false,
						isDisabled: false,
						isAdded: false,
						created_at: '12/04/2017 - 9:00 a.m.',
						flagactive: 1,
					},
					{
						id: 2,
						code: 'OS',
						icon: 'dirty',
						number: '5202',
						clean_state: 1,
						isSelected: false,
						isDisabled: false,
						isAdded: false,
						created_at: '12/04/2017 - 9:00 a.m.',
						flagactive: 1,
					},
					{
						id: 3,
						code: 'OS',
						icon: 'dirty',
						number: '5203',
						clean_state: 1,
						isDisabled: false,
						isSelected: false,
						isAdded: false,
						created_at: '12/04/2017 - 9:00 a.m.',
						flagactive: 1,
					},
					{
						id: 4,
						code: 'OS',
						icon: 'dirty',
						number: '5204',
						clean_state: 1,
						isSelected: false,
						isDisabled: false,
						isAdded: false,
						created_at: '12/04/2017 - 9:00 a.m.',
						flagactive: 1,
					},
					{
						id: 5,
						code: 'OS',
						icon: 'dirty',
						number: '5205',
						clean_state: 1,
						isSelected: false,
						isDisabled: false,
						isAdded: false,
						created_at: '12/04/2017 - 9:00 a.m.',
						flagactive: 1,
					},
				],
				rowsSelected: null,
				states: [
					{
						id: 1,
						name: 'Ocupado sucio',
						code: 'OS',
						icon: 'dirty',
						number: '5201',
						state: 'booking',
					},
					{
						id: 2,
						name: 'Vacante sucio',
						code: 'VS',
						icon: 'dirty',
						number: '5201',
					},
					{
						id: 3,
						name: 'Turn Over',
						code: 'TO',
						icon: 'turnover',
						number: '5201',
					},
					{
						id: 4,
						name: 'Mantenimiento',
						code: 'M',
						icon: 'maintenance',
						number: '5201',
					},
					{
						id: 5,
						name: 'Limpieza profunda',
						code: 'LP',
						icon: 'cleandeep',
						number: '5201',
					},
					{
						id: 6,
						name: 'Ocupado limpio',
						code: 'OL',
						number: '5201',
					},
					{
						id: 7,
						name: 'Vacante limpio',
						code: 'VL',
						number: '5201',
					},
					{
						id: 8,
						name: 'Fuera de servicio',
						code: 'FS',
						icon: 'outofservice',
						number: '5201',
					},
					{
						id: 9,
						name: 'Bloqueado',
						code: 'B',
						icon: 'locked',
						number: '5201',
					},
				],
				subsidiaryId: 0,
				userAdded: null,
				users: [
					{
						id: 1,
						name: 'Maria Chiappe',
						image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
						assignments: '12 habitaciones',
					},
					{
						id: 2,
						name: 'Maria Chiappe 2',
						image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
						assignments: '12 habitaciones',
					},
					{
						id: 3,
						name: 'Maria Chiappe 3',
						image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
						assignments: '12 habitaciones',
					},
					{
						id: 4,
						name: 'Maria Chiappe 4',
						image_url: 'https://static.boredpanda.com/blog/wp-content/uploads/2016/01/cute-squirrel-photography-361__700.jpg',
						assignments: '12 habitaciones',
					},
				],
				userSelected: null,
				// Snackbar
				context: '',
				snackbar: false,
				text: '',
				timeout: 3000,
			};
		},
	};
</script>

<style lang="scss" scoped>
	.padding-responsive {
		padding-right: 4.6%;
	}

	.select-clean-type {
		width: 238px;
	}

	.subtitle-right {
		color: map-get($colors, default-label);
		float: right;
		font-size: 12px;
		margin-right: 9.5px;
	}

	.wrap-select-rooms {
		max-width: calc(100% - 249px);
	}

	.full-layout-white {
		background-color: white;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .18);
		padding: 21px 20px;
	}

	label.clean-type {
		align-items: center;
		background: transparent;
		border: 1px solid map-get($colors, border-radio);
		border-radius: 100px;
		color: map-get($colors, default-button-color);
		cursor: pointer;
		display: inline-flex;
		font-size: map-get($sizes, twelve);
		height: 33px;
		justify-content: center;
		margin: 19px 13px 9px 0px;
		width: 95px;
	}

	input.input-clean-type:checked + .clean-type {
		background: map-get($colors, radio-input-blue);
		border-color: map-get($colors, radio-input-blue);
		color: white;
	}

	textarea {
		border: 1px solid map-get($colors, e-bg-icon);
	}

	.empty-container {
		min-height: 61px;
	}
</style>




// WEBPACK FOOTER //
// DetailByState.vue?ba12c154